export const HOWARD_COUNTY_BASE_URL = "https://www.howardcountymd.gov";

export const HOWARD_COUNTY_LINKS = {
  accessibility: `${HOWARD_COUNTY_BASE_URL}/accessibility`,
  termsOfUse: `${HOWARD_COUNTY_BASE_URL}/terms-use`,
  privacyStatement: `${HOWARD_COUNTY_BASE_URL}/privacy-statement`,
} as const;
